import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import MailIcon from '@mui/icons-material/Mail';
import PhoneIcon from '@mui/icons-material/Phone';
import WorkIcon from '@mui/icons-material/Work';
import '../assets/styles/Footer.scss'

function Footer() {
  return (
    <footer>
      <div>
        <a href="https://github.com/genesis-solution" target="_blank" rel="noreferrer"><GitHubIcon/></a>
        <a href="https://www.linkedin.com/in/jonathan-rann" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
        <a href="https://www.guru.com/freelancers/genesis-solutions" target="_blank" rel="noreferrer"><WorkIcon/></a>
        <a href="mailto:jCheshireRann@gmail.com" target="_blank" rel="noreferrer"><MailIcon/></a>
        <a href="tel:336-575-5961" target="_blank" rel="noreferrer"><PhoneIcon/></a>
      </div>
      <p>A portfolio for <strong>The Project Genesis LLC</strong> — designed & built by <a href="https://www.linkedin.com/in/jonathan-rann" target="_blank" rel="noreferrer">Dr. Jonathan Rann</a>, CEO.</p>
    </footer>
  );
}

export default Footer;